import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, isRef as _isRef, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex items-center mb-x6 last:mb-0 relative" }
const _hoisted_2 = ["for"]
const _hoisted_3 = { class: "c-checkbox" }
const _hoisted_4 = ["id", "value", "disable"]
const _hoisted_5 = { class: "flex w-full items-center" }
const _hoisted_6 = { class: "ml-x1 mr-x4" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "text-16 text-left max-w-400" }
const _hoisted_9 = { class: "leading-10" }
const _hoisted_10 = {
  key: 0,
  class: "ml-auto text-right"
}

import {
    BaseProductItem,
    ItemType,
    ItemMessageType,
    ModuleSofaConfigurationProductItem,
    OutletProductItem,
    LabelForItem,
} from '@/storecontext/shared/api/server-apis';
import { computed } from 'vue';
import ItemMessages from '@/storecontext/shared/checkout/ui/ItemMessages.vue';
import { useVModel } from '@vueuse/core';
import { useCheckout } from '@/storecontext/checkout/useCheckout';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';


export default /*#__PURE__*/_defineComponent({
  __name: 'SplitDeliveryItem',
  props: {
    item: null,
    deliverableId: null,
    modelValue: null,
    totalItems: null
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props as {
    item: ModuleSofaConfigurationProductItem | BaseProductItem | OutletProductItem;
    deliverableId: number;
    modelValue: ModuleSofaConfigurationProductItem[] | BaseProductItem[] | OutletProductItem[];
    totalItems: number;
}




const value = useVModel(props, 'modelValue', emit);
const { deliveryInfo } = useCheckout();
const labels = useBlockLabels();

const earliestDeliveryDatesForItems = computed<LabelForItem[] >(() => {
    return deliveryInfo.value[props.deliverableId].labelForItems ?? [] as LabelForItem[];
});

const earliestDeliveryDate = computed<string>(() => {
    const itemLabel = earliestDeliveryDatesForItems.value.find((label) => label.itemId === props.item.id);
    return itemLabel?.label.namedParams.date || null;
});

const moduleSofaItemImage = computed(() => {
    return 'image' in props.item && (props.item.type === ItemType.ModuleSofa || props.item.type === ItemType.ModuleConfiguration) ? props.item.image : null;
});

const hub = computed(() => {
    return 'hub' in props.item ? props.item.hub : null;
});

const hasSelectedItemWithDifferentHub = computed(() => {
    const selectedItemsWithHub = props.modelValue.filter(val => (val as OutletProductItem).hub);
    return hub.value && selectedItemsWithHub.find(s => (s as OutletProductItem).hub !== hub.value);
});

const isItemInList = computed(() => {
    return !!props.modelValue.find(val => val.id === props.item.id);
});

const hasSelectedAllButOne = computed(() => {
    return !isItemInList.value &&
    props.modelValue.length &&
    props.modelValue.length === props.totalItems - 1;
});

const shouldDisable = computed(() => {
    return hasSelectedItemWithDifferentHub.value || hasSelectedAllButOne.value || props.totalItems === 1;
});

const itemMessages = computed(() => {
    return [...props.item.primaryItemMessages, ...props.item.secondaryItemMessages];
});


return (_ctx: any,_cache: any) => {
  const _component_ProductImage = _resolveComponent("ProductImage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      for: !_unref(shouldDisable) ? __props.item.id+'' : '',
      class: _normalizeClass(["absolute inset-0 z-1", {'cursor-pointer': !_unref(shouldDisable)}])
    }, null, 10, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("input", {
        id: __props.item.id+'',
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(value) ? (value).value = $event : null)),
        value: __props.item,
        disable: _unref(shouldDisable),
        type: "checkbox",
        class: _normalizeClass(["c-checkbox__field", {'opacity-50' : _unref(shouldDisable)}])
      }, null, 10, _hoisted_4), [
        [_vModelCheckbox, _unref(value)]
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["c-checkbox__label h-25", {'text-gainsboro-grey' : _unref(shouldDisable)}])
      }, null, 2)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        (_unref(moduleSofaItemImage))
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _unref(moduleSofaItemImage),
              class: "w-75"
            }, null, 8, _hoisted_7))
          : (_openBlock(), _createBlock(_component_ProductImage, {
              key: 1,
              sku: __props.item.sku,
              alt: __props.item.name,
              "aspect-ratio": 4/3,
              "width-on-screen": 1,
              class: "w-75"
            }, null, 8, ["sku", "alt"]))
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("p", _hoisted_9, _toDisplayString(__props.item.name), 1),
        _createVNode(_TransitionGroup, {
          name: "o-anim-fade-300",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (_unref(hub))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 'hub'+__props.item.id,
                  class: "text-12 leading-11 mt-8"
                }, [
                  _createTextVNode(_toDisplayString(_ctx.$dictionary.formatNamed(_unref(labels).splitDeliveryDialogItemCanBePickedUpMessage, {hub: _unref(hub)})) + " ", 1),
                  ('canBeDelivered' in __props.item && __props.item.canBeDelivered)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_unref(labels).splitDeliveryDialogItemCanBePickedUpOrDeliveredNearByMessage), 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_unref(hasSelectedItemWithDifferentHub))
              ? (_openBlock(), _createElementBlock("p", {
                  key: `disable-msg${__props.item.id}}`,
                  class: "text-12 text-roman"
                }, _toDisplayString(_unref(labels).splitDeliveryDialogItemCanNotBeDeliveredInTheSameDelivery), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(ItemMessages, {
          messages: _unref(itemMessages),
          type: _unref(ItemMessageType).CheckOut,
          class: "text-12"
        }, null, 8, ["messages", "type"])
      ]),
      (_unref(earliestDeliveryDate))
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_unref(earliestDeliveryDate)), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})